import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/empty.png'


const _withScopeId = n => (_pushScopeId("data-v-3dfed416"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container py-3 px-3 min-vh-50" }
const _hoisted_2 = { class: "experience-container" }
const _hoisted_3 = { class: "col-12 col-md-6 experience-container-info" }
const _hoisted_4 = { class: "experience-container-info-image" }
const _hoisted_5 = {
  key: 0,
  id: "carouselpc-experience",
  class: "carousel slide"
}
const _hoisted_6 = { class: "carousel-indicators" }
const _hoisted_7 = ["data-bs-slide-to", "aria-current", "aria-label"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "carousel-inner" }
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 2,
  src: _imports_0,
  class: "image-item",
  alt: "experience"
}
const _hoisted_14 = {
  key: 0,
  class: "experience-container-info-hashtag"
}
const _hoisted_15 = { class: "experience-container-info-title" }
const _hoisted_16 = { class: "experience-container-info-description" }
const _hoisted_17 = {
  key: 1,
  class: "merch-container-info-item"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "🧑‍🏫", -1))
const _hoisted_19 = { class: "weight" }
const _hoisted_20 = {
  key: 2,
  class: "merch-container-info-item"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "👥", -1))
const _hoisted_22 = { class: "weight" }
const _hoisted_23 = {
  key: 3,
  class: "merch-container-info-item"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "🕰", -1))
const _hoisted_25 = { class: "weight" }
const _hoisted_26 = {
  key: 4,
  class: "merch-container-info-item"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "🧑‍🦽", -1))
const _hoisted_28 = { class: "weight" }
const _hoisted_29 = { class: "col-12 col-md-4" }
const _hoisted_30 = { class: "experience-container-calendar" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "experience-container-calendar-title" }, "Calendario", -1))
const _hoisted_32 = {
  key: 0,
  class: "experience-container-calendar-subtitle"
}
const _hoisted_33 = {
  key: 1,
  class: "experience-container-calendar-timeranges"
}
const _hoisted_34 = ["onClick", "onKeydown", "disabled"]
const _hoisted_35 = {
  key: 2,
  class: "experience-container-calendar-subtitle"
}
const _hoisted_36 = {
  key: 3,
  class: "experience-container-calendar-tickets"
}
const _hoisted_37 = { class: "experience-container-calendar-tickets-item-title" }
const _hoisted_38 = { class: "experience-container-calendar-tickets-item-buttons" }
const _hoisted_39 = ["onClick", "onKeydown"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-dash-lg" }, null, -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = ["onClick", "onKeydown"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = { key: 4 }
const _hoisted_46 = { class: "experience-container-calendar-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FullCalendar = _resolveComponent("FullCalendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          ($setup.images.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.images, (img, ix) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: ix,
                      type: "button",
                      "data-bs-target": "#carouselpc-experience",
                      "data-bs-slide-to": ix,
                      class: _normalizeClass((ix === 0 ? 'active' : '')),
                      "aria-current": ix === 0,
                      "aria-label": 'Slide ' + ix.toString()
                    }, _hoisted_9, 10, _hoisted_7))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.images, (img, ix) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: ix,
                      class: _normalizeClass(["carousel-item", (ix === 0 ? 'active' : '')])
                    }, [
                      _createElementVNode("img", {
                        src: $setup.getSrc(ix),
                        class: "d-block image-item",
                        alt: ""
                      }, null, 8, _hoisted_11)
                    ], 2))
                  }), 128))
                ])
              ]))
            : ($setup.images.length === 1)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: $setup.getSrc(0),
                  class: "image-item",
                  alt: "experience"
                }, null, 8, _hoisted_12))
              : (_openBlock(), _createElementBlock("img", _hoisted_13))
        ]),
        ($setup.hashtag)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString($setup.hashtag), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_15, _toDisplayString($setup.name), 1),
        _createElementVNode("p", _hoisted_16, _toDisplayString($setup.description), 1),
        ($setup.infoGuide)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("span", _hoisted_19, _toDisplayString($setup.infoGuide), 1)
            ]))
          : _createCommentVNode("", true),
        ($setup.infoGroup)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("span", _hoisted_22, _toDisplayString($setup.infoGroup), 1)
            ]))
          : _createCommentVNode("", true),
        ($setup.infoTime)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("span", _hoisted_25, _toDisplayString($setup.infoTime), 1)
            ]))
          : _createCommentVNode("", true),
        ($setup.infoDisability)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("span", _hoisted_28, _toDisplayString($setup.infoDisability), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createElementVNode("div", null, [
            _createVNode(_component_FullCalendar, { options: $setup.calendarOptions }, null, 8, ["options"])
          ]),
          ($setup.timeranges.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, "Seleziona l'orario della tua esperienza"))
            : _createCommentVNode("", true),
          ($setup.timeranges.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.timeranges, (t) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: t.id,
                    class: _normalizeClass(["experience-container-calendar-timeranges-item", { 'active': $setup.isTimerangeActive(t.id), 'no-drop': $setup.isTimerangeDisabled(t.timerange) }]),
                    onClick: ($event: any) => ($setup.selectTimerange(t.id)),
                    onKeydown: ($event: any) => ($setup.selectTimerange(t.id)),
                    disabled: $setup.isTimerangeDisabled(t.timerange)
                  }, _toDisplayString(t.timerange), 43, _hoisted_34))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          ($setup.tickets.length > 0 && $setup.availableTickets > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, "Seleziona il numero di biglietti"))
            : _createCommentVNode("", true),
          ($setup.tickets.length > 0 && $setup.availableTickets > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tickets, (tk) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: tk.id,
                    class: "experience-container-calendar-tickets-item"
                  }, [
                    _createElementVNode("div", _hoisted_37, _toDisplayString(tk.name) + " - € " + _toDisplayString(tk.price.toFixed(2)), 1),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("button", {
                        class: "btn btn-icon btn-outline-dark",
                        onClick: ($event: any) => ($setup.less(tk.id)),
                        onKeydown: ($event: any) => ($setup.less(tk.id))
                      }, _hoisted_41, 40, _hoisted_39),
                      _createElementVNode("span", null, _toDisplayString($setup.getTicketQta(tk.id)), 1),
                      _createElementVNode("button", {
                        class: "btn btn-icon btn-outline-dark",
                        onClick: ($event: any) => ($setup.plus(tk.id)),
                        onKeydown: ($event: any) => ($setup.plus(tk.id))
                      }, _hoisted_44, 40, _hoisted_42)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          ($setup.errorMessageTickets != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString($setup.errorMessageTickets), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_46, [
            ($setup.counter > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-pc btn-pc-primary",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.addToCart && $setup.addToCart(...args))),
                  onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.addToCart && $setup.addToCart(...args)))
                }, _toDisplayString(_ctx.$t('common.addtocart')), 33))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "btn btn-pc btn-pc-secondary",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.goToCart && $setup.goToCart(...args))),
              onKeydown: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.goToCart && $setup.goToCart(...args)))
            }, _toDisplayString(_ctx.$t('common.gotocheckout')), 33)
          ])
        ])
      ])
    ])
  ]))
}